if (!customElements.get('swatch-list')) {
  class SwatchList extends HTMLElement {
    constructor() {
      super();
      this.mobileMaxVisibleCount = parseInt(this.dataset.mobileMax, 10);
      this.desktopMaxVisibleCount = parseInt(this.dataset.desktopMax, 10);
      this.remainingCounterElement = null;
      this.handleBreakpointChange = this.handleBreakpointChange.bind(this);
      this.desktopBreakpoint = window.matchMedia('(min-width: 1024px)');
    }

    connectedCallback() {
      if (this.initialized) {
        this.handleBreakpointChange();
        return;
      }

      const hasMobileLimit = !isNaN(this.mobileMaxVisibleCount) && this.mobileMaxVisibleCount > 0;
      const hasDesktopLimit = !isNaN(this.desktopMaxVisibleCount) && this.desktopMaxVisibleCount > 0;

      if (!hasMobileLimit && !hasDesktopLimit) return;

      this.swatchElements = Array.from(this.querySelectorAll('color-swatch'));

      const effectiveMobileMax = hasMobileLimit ? this.mobileMaxVisibleCount : Infinity;
      const effectiveDesktopMax = hasDesktopLimit ? this.desktopMaxVisibleCount : Infinity;

      if (this.swatchElements.length <= effectiveMobileMax && this.swatchElements.length <= effectiveDesktopMax) return;

      const counterTemplate = this.querySelector('.swatch-counter-template');
      if (!counterTemplate) return;

      // Remove any existing counter before appending to prevent duplicates
      const existingCounter = this.querySelector('.swatch-counter');
      if (existingCounter) existingCounter.remove();

      this.remainingCounterElement = counterTemplate.content.firstElementChild.cloneNode(true);
      this.remainingCounterElement.classList.add('swatch-counter');
      this.appendChild(this.remainingCounterElement);

      this.initialized = true;
      this.desktopBreakpoint.addEventListener('change', this.handleBreakpointChange);
      this.handleBreakpointChange();
    }

    disconnectedCallback() {
      this.desktopBreakpoint.removeEventListener('change', this.handleBreakpointChange);
    }

    handleBreakpointChange() {
      const isDesktop = this.desktopBreakpoint.matches;
      const hasMobileLimit = !isNaN(this.mobileMaxVisibleCount) && this.mobileMaxVisibleCount > 0;
      const hasDesktopLimit = !isNaN(this.desktopMaxVisibleCount) && this.desktopMaxVisibleCount > 0;

      const maxVisible = isDesktop
        ? (hasDesktopLimit ? this.desktopMaxVisibleCount : Infinity)
        : (hasMobileLimit ? this.mobileMaxVisibleCount : Infinity);

      this.swatchElements.forEach((swatchElement, index) => {
        swatchElement.style.display = index < maxVisible ? '' : 'none';
      });

      if (this.remainingCounterElement) {
        const hiddenCount = this.swatchElements.length - maxVisible;
        if (hiddenCount > 0) {
          this.remainingCounterElement.textContent = `+${hiddenCount}`;
          this.remainingCounterElement.style.display = '';
        } else {
          this.remainingCounterElement.style.display = 'none';
        }
      }
    }
  }

  customElements.define('swatch-list', SwatchList);
}